import {atom} from 'jotai';

const metamorInfo = atom({})

export {metamorInfo}
